import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleTranslateService {
  private renderer: Renderer2;
  private isScriptLoaded: boolean = false;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  initGoogleTranslate(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (this.isScriptLoaded) {
        this.googleTranslateElementInit();
        resolve();
        return;
      }

      const existingScript = document.getElementById('google-translate-script');
      if (existingScript) {
        this.googleTranslateElementInit();
        this.isScriptLoaded = true;
        resolve();
        return;
      }

      const googleTranslateScript = this.renderer.createElement('script');
      googleTranslateScript.id = 'google-translate-script';
      googleTranslateScript.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      googleTranslateScript.async = true;
      googleTranslateScript.defer = true;

      (window as any).googleTranslateElementInit = this.googleTranslateElementInit.bind(this);

      googleTranslateScript.onload = () => {
        this.isScriptLoaded = true;
        resolve();
      };
      googleTranslateScript.onerror = (error) => reject(error);

      this.renderer.appendChild(document.head, googleTranslateScript);
    });
  }

  googleTranslateElementInit() {
    if (typeof google !== 'undefined' && (window as any).google.translate && (window as any).google.translate.TranslateElement) {
      new (window as any).google.translate.TranslateElement({
        pageLanguage: 'en',
        autoDisplay: false,
        multilanguagePage: true
      }, 'google_translate_element');
    } else {
      console.error('Google Translate script is not fully loaded or initialized.');
    }
  }

  setGoogleTranslateLanguage(selectedLangCode: string) {
    const googleTranslateElement = document.querySelector('.goog-te-combo') as HTMLSelectElement;
    if (googleTranslateElement) {
      googleTranslateElement.value = selectedLangCode;
      googleTranslateElement.dispatchEvent(new Event('change'));
      
    } else {
      console.error('Google Translate combo box not found.');
    }
  }
}
